// Config centralizzata per costanti applicative
// Aggiungi qui gli UID che devono poter accedere alla dashboard
export const ADMIN_UIDS = [
  "QKWl9UFABzOOfXWwLzzmvtnnjGt1" // UID iniziale (sostituisci / aggiungi i tuoi)
];
